const UTM_IDENTITIES = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term"
];
const generateFlexUTMs = (query) => Object.entries(query).reduce((accumulator, [key, value]) => {
  if (UTM_IDENTITIES.includes(key)) {
    accumulator[`flex_${key}`] = value;
  }
  return accumulator;
}, {});

export { UTM_IDENTITIES, generateFlexUTMs };
//# sourceMappingURL=generateFlexUTMs.mjs.map
